import BasePageView from "components/core/BasePageView/BasePageView";
import useHomePageLogic from "./useHomePageLogic";
import HomePageDesktop from "./HomePageDesktop";
import HomePageMobile from "./HomePageMobile";

const HomePage = () => {
  const vm = useHomePageLogic();

  const headerProps = {
    showSubHeader: vm.showSubHeader,
    sellerDetail: vm.currentSellerDetail,
    allSellerDetails: vm.allSellersDetails,
    handleProfile: vm.handleProfileNavigate,
    isHomePage: true,
  };

  return (
    <BasePageView
      DesktopView={HomePageDesktop}
      MobileView={HomePageMobile}
      viewProps={vm}
      headerProps={headerProps}
    />
  );
};

export default HomePage;
